export default function normFile(e: any) {
  console.log("Upload event:", e);

  return Array.isArray(e) ? e : e?.fileList;
}
